import Vue from 'vue';
import Router from 'vue-router';

import office_home from '@/components/office/home/office_home';
import office_user from '@/components/office/user/office_user';

import office_surat_kirim from '@/components/office/surat_kirim/surat_kirim';
import office_surat_masuk from '@/components/office/surat_masuk/surat_masuk';
import office_surat_terusan from '@/components/office/surat_terusan/surat_terusan';
import office_ttd_surat from '@/components/office/ttd_surat/surat_ttd';
import office_validasi_surat from '@/components/office/validasi_surat/validasi_surat';
import office_agenda_keluar from './components/office/agenda/agenda_keluar.vue';
import office_agenda_masuk from './components/office/agenda/agenda_masuk.vue';
import office_borang_acu from './components/office/borang_acu/borang_acu.vue';




// import './assets/css/kiken/kiken.css'

Vue.use(Router)



function loggedInRedirectDashboard(to, from, next) {
  if (localStorage.token) {
    next('/dashboard');
  } else {
    next();
  }
}

function isLoggedIn(to, from, next) {
  if (localStorage.token) {
    next();
  } else {
    next('/monev_login');
  }
}

var routes = [
    {
        path: '/office',
        name: '/office',
        component: office_home,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/office_surat_kirim',
        name: '/office_surat_kirim',
        component: office_surat_kirim,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/office_surat_masuk',
        name: '/office_surat_masuk',
        component: office_surat_masuk,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/office_surat_terusan',
        name: '/office_surat_terusan',
        component: office_surat_terusan,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/office_ttd_surat',
        name: '/office_ttd_surat',
        component: office_ttd_surat,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/office_validasi_surat',
        name: '/office_validasi_surat',
        component: office_validasi_surat,
        beforeEnter: isLoggedIn,
    },
    {
      path: '/office_user',
      name: '/office_user',
      component: office_user,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/office_agenda_keluar',
      name: '/office_agenda_keluar',
      component: office_agenda_keluar,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/office_agenda_masuk',
      name: '/office_agenda_masuk',
      component: office_agenda_masuk,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/office_borang_acu',
      name: '/office_borang_acu',
      component: office_borang_acu,
      beforeEnter: isLoggedIn,
    },


  
  
  ]



export default routes